import React from 'react';
import MyJams from '../components/game/MyJams/MyJams';

export const MyJamsPage: React.FC = () => {
  return <MyJams />;
};
